<template>
  <div>
    <van-button
      type="primary"
      :text="$t('index.language')"
      @click="show = true"
    />
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block" style="padding:20px 30px;border-radius: 10px;height:150px">
          <van-radio-group v-model="radio">
            <van-radio
              v-for="(item,index) in sendItems"
              :key="index"
              class="radio_item"
              :name="item.id"
              @click="changePay(item.id)"
            >{{item.name}}</van-radio>
          </van-radio-group>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import home from '@/api/home';
export default {
  data() {
    return {
      show: false,
      radio: "1",
      sendItems: [
        {
          id: "1",
          name: "中文繁體"
        },
        {
          id: "2",
          name: "中文简体"
        },
        {
          id: "3",
          name: "English"
        },
        {
          id: "4",
          name: "Malay"
        },{
          id: "5",
          name: "日本語"
        }
      ]
    };
  },
  methods: {
    changePay(item) {
      this.show = false;
      if (item == 1) {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "tw");
      } else if (item == 2) {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "zh");
      } else if (item == 3) {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "en");
      } else if(item == 4){
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "ma");
      }else{
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "ja");
      }
    },
    getasd(){
      let url = location.host;
      home.region(url).then((res) => {
        //  console.log('resresresres',res)
         if(res.region=='台灣'){
            let locale = this.$i18n.locale;
            locale === "null" ? (this.$i18n.locale = "tw") : (this.$i18n.locale = "tw");
            sessionStorage.setItem('locale','tw')
         }else if(res.region=='Malaysia'){
           let locale = this.$i18n.locale;
            locale === "null" ? (this.$i18n.locale = "ma") : (this.$i18n.locale = "ma");
           sessionStorage.setItem('locale','ma') 
         }else if(res.region=='日本'){
          let locale = this.$i18n.locale;
            locale === "null" ? (this.$i18n.locale = "ja") : (this.$i18n.locale = "ja");
            sessionStorage.setItem('locale','ja')
         }else if(res.region=='ประเทศไทย'){
           let locale = this.$i18n.locale;
            locale === "null" ? (this.$i18n.locale = "tg") : (this.$i18n.locale = "tg");
            sessionStorage.setItem('locale','tg')
         }else if(res.region=='Singapore'){
           let locale = this.$i18n.locale;
           locale === "null" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "en");
           sessionStorage.setItem('locale','en')
         }else if(res.region=='香港'){
           let locale = this.$i18n.locale;
           locale === "null" ? (this.$i18n.locale = "hk") : (this.$i18n.locale = "hk");
           sessionStorage.setItem('locale','hk')
         }
      });
    }
  },
  created(){
    this.getasd()
  }
};
</script>
<style scoped>



</style>


// WEBPACK FOOTER //
// src/pages/index/common/Language.vue